import { createFileRoute, redirect } from "@tanstack/react-router";

// /settings has no content of its own — land on the Profile tab.
export const Route = createFileRoute("/_auth/_agents/settings/")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/profile" });
  },
});
